import CarHireCheapestLocation from './CarHireCheapestLocation';

export default CarHireCheapestLocation;
